import useMedia from 'hooks/useMedia';
import { useEffect, useState } from 'react';
import { ThemeMode } from 'types/theme';

type UseDarkModeReturn = [ThemeMode, () => void];

const useDarkMode = (): UseDarkModeReturn => {
  const [theme, setTheme] = useState<ThemeMode>('light');

  const toggleTheme = () => {
    if (theme === 'light') {
      window.localStorage.setItem('theme', 'dark');
      setTheme('dark');
    } else {
      window.localStorage.setItem('theme', 'light');
      setTheme('light');
    }
  };

  const prefersDarkMode = useMedia<boolean>(
    ['(prefers-color-scheme: dark)'],
    [true],
    false
  );

  useEffect(() => {
    const localTheme = window.localStorage.getItem('theme') as ThemeMode | null;
    if (localTheme) {
      setTheme(localTheme);
    } else if (prefersDarkMode) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  }, [prefersDarkMode]);

  return [theme, toggleTheme];
};

export default useDarkMode;
